import { ReactComponent as OperationalIcon } from './../assets/icons/component_status_operational.svg';
import { ReactComponent as DegradedIcon } from './../assets/icons/component_status_degraded.svg';
import { ReactComponent as PartialOutageIcon } from './../assets/icons/component_status_partial_outage.svg';
import { ReactComponent as MajorOutageIcon } from './../assets/icons/component_status_major_outage.svg';
import { ReactComponent as UnderMaintenanceIcon } from './../assets/icons/component_status_under_maintenance.svg';

// Monitoring services 
import { ReactComponent as WebhookIcon } from './../assets/icons/webhooks.svg'
import { ReactComponent as ChecklyIcon } from './../assets/icons/checkly.monitoring-service.svg'
import { ReactComponent as UptimerobotIcon } from './../assets/icons/uptimerobot.monitoring-service.svg'
import { ReactComponent as PingdomIcon } from './../assets/icons/pingdom.monitoring-service.svg'
import { ReactComponent as GmailIcon } from './../assets/icons/gmail.svg'
import { ReactComponent as BetterUptimeIcon } from './../assets/icons/betteruptime.monitoring-service.svg'
import { ReactComponent as DatadogIcon } from './../assets/icons/datadog.monitoring-service.svg'
import { ReactComponent as FreshpingIcon } from './../assets/icons/freshping.monitoring-service.svg'
import { ReactComponent as HetrixToolsIcon } from './../assets/icons/hetrixtools.monitoring-service.svg'
import { ReactComponent as PagerDutyIcon } from './../assets/icons/pagerduty.monitoring-service.svg'
import { ReactComponent as RunscopeIcon } from './../assets/icons/runscope.monitoring-service.svg'
import { ReactComponent as Site24x7Icon } from './../assets/icons/site24x7.monitoring-service.svg'
import { ReactComponent as StatusCakeIcon } from './../assets/icons/statuscake.monitoring-service.svg'

const moment = require('moment')


export const incidentStatus = [
	{
		
		id : 'INVESTIGATING' , 
		name : 'Investigating' , 
		status : 'danger' , 
		placeholder : "We are currently investigating this issue.",
		automate_incident_message : "Website cannot be accessed at the moment. This incident was created by an automated monitoring service.",
		globalColor : 'red',
	},
	{
		
		id : 'IDENTIFIED' , 
		name : 'Identified' , 
		status : 'warning' , 
		placeholder : "The issue has been identified and a fix is being implemented.",
		globalColor : 'yellow',
	},
	{
		
		id : 'MONITORING' , 
		name : 'Monitoring' , 
		status : 'monitoring' , 
		placeholder : "A fix has been implemented and we are monitoring the results.",
		globalColor : 'blue',
	},
	{
		
		id : 'RESOLVED' , 
		name : 'Resolved' , 
		status : 'success' , 
		placeholder : "This incident has been resolved.",
		automate_incident_message : "Website is now operational! This update was created by an automated monitoring service.",
		globalColor : 'green',
	},
]

const maintenanceStatus = [
	{
		id : 'SCHEDULED' , name : 'Scheduled' , status : 'danger' ,
	},
	{
		id : 'INPROGRESS' , name : 'In Progress' , status : 'warning' ,
	},
	{
		id : 'VERIFING' , name : 'Verifing' , status : 'warning' ,
	},
	{
		id : 'COMPLETED' , name : 'Completed' , status : 'success' ,
	},
];

export const incidentImpact = [
	{ value : 'NONE' , label : "None" , color : "gray"},
	{ value : 'MINOR' , label : "Minor"  , color : "yellow"},
	{ value : 'MAJOR' , label : "Major" , color : "orange" },
	{ value : 'CRITICAL' , label : "Critical" , color : "red"},
	{ value : 'MAINTENANCE' , label : "Maintenance" , color : "blue"}
];

export const pageTopLevelStatus = [
	{
        value : 'ALL-SYSTEMS-OPERATIONAL',
        label : 'All Systems Operational',
        color : 'green',
    },
    {
        value : 'MAJOR-SYSTEM-OUTAGE',
        label : 'Major System Outage',
        color : 'red',
    },    
    {
        value : "PARTIAL-SYSTEM-OUTAGE",
        label : 'Partial System Outage',
        color : 'orange',
    },    
    {
        value : "MINOR-SERVICE-OUTAGE",
        label : 'Minor Service Outage',
        color : 'yellow',
    },    
    {
        value : "DEGRADED-SYSTEM-SERVICE",
        label : 'Degraded System Service',
        color : 'yellow',
    },    
    {
        value : "PARTIALLY-DEGRADED-SERVICE",
        label : 'Partially Degraded Service',
        color : 'yellow',
    },    
    {
        value : "SERVICE-UNDER-MAINTENANCE",
        label : 'Service Under Maintenance',
        color : 'blue',
    },   
];

export const componentStatus = [
	{ 
		value : "OPERATIONAL" , 
		label  : 'Operational' , 
		icon : <OperationalIcon fill="white" color="#2fcc66"/>,
		color: "#2fcc66",
        color_name : 'green'
	},
	{ 
		value : "DEGRADED-PERFORMANCE" , 
		label  : 'Degraded performance' , 
		icon : <DegradedIcon fill="white" color="#ffc400"/>,
		color: "#ffc400",
        color_name : 'yellow'
	},
	{ 
		value : "PARTIAL-OUTAGE" , 
		label  : 'Partial outage' , 
		icon : <PartialOutageIcon fill="white" color="#ff8b00"/>,
		color: "#ff8b00",
        color_name : 'orange'
	},
	{ 
		value : "MAJOR-OUTAGE" , 
		label  : 'Major outage' , 
		icon : <MajorOutageIcon fill="white" color="#de350b"/>,
		color: "#de350b",
        color_name : 'red'
	},
	{ 
		value : "UNDER-MAINTENANCE" , 
		label  : 'Under maintenance' , 
		icon : <UnderMaintenanceIcon fill="white" color="#3498db"/>,
		color: "#3498db",
        color_name : 'blue'
	},
]

export const automateMonitoringService = [
	{
		value : 'webhook' , 
		label : 'Webhook' , 
		description : 'Send webhooks to update your status page' , 
		image : <WebhookIcon width={24} height={24} /> ,
		is_active : true,
        displayed : true
	},
	{
		value : 'pingdom' , 
		label : 'Pingdom',
		description : 'Send webhooks to update your status page' , 
		image : <PingdomIcon width={24} height={24} /> ,
		is_active : true,
        displayed : true
	},
	{
		value : 'uptimerobot' , 
		label : 'Uptimerobot',
		description : 'Send webhooks to update your status page' , 
		image : <UptimerobotIcon width={24} height={24} /> ,
		is_active : true,
        displayed : true
	},
	{
		value : 'checkly' , 
		label : 'Checkly',
		description : 'Send webhooks to update your status page' , 
		image : <ChecklyIcon width={24} height={24} /> ,
		is_active : true,
        displayed : true
	},
	// {
	// 	value : 'email' , 
	// 	label : 'Email' , 
	// 	description : 'Send webhooks to update your status page' , 
	// 	image : <GmailIcon width={24} height={24} /> ,
	// 	is_active : false,
    //     displayed : true
	// },
	// {
	// 	value : 'betteruptime' , 
	// 	label : 'Better Uptime',
	// 	description : 'Send webhooks to update your status page' , 
	// 	image : <BetterUptimeIcon width={24} height={24} /> ,
	// 	is_active : false,
    //     displayed : true
	// },
	{
		value : 'datadog' , 
		label : 'Datadog',
		description : 'Send webhooks to update your status page' , 
		image : <DatadogIcon width={24} height={24} /> ,
		is_active : true,
        displayed : true
	},
	// {
	// 	value : 'freshping' , 
	// 	label : 'Freshping',
	// 	description : 'Send webhooks to update your status page' , 
	// 	image : <FreshpingIcon width={24} height={24} /> ,
	// 	is_active : false,
    //     displayed : true
	// },
	{
		value : 'hetrixtools' , 
		label : 'HetrixTools' , 
		description : 'Send webhooks to update your status page' , 
		image : <HetrixToolsIcon width={24} height={24} /> ,
		is_active : true,
        displayed : true
	},
	{
		value : 'pagerduty' , 
		label : 'PagerDuty',
		description : 'Send webhooks to update your status page' , 
		image : <PagerDutyIcon width={24} height={24} /> ,
		is_active : true,
        displayed : true
	},
	{
		value : 'runscope' , 
		label : 'Runscope',
		description : 'Send webhooks to update your status page' , 
		image : <RunscopeIcon width={24} height={24} /> ,
		is_active : true,
        displayed : true
	},
	{
		value : 'site24x7' , 
		label : 'Site24x7',
		description : 'Send webhooks to update your status page' , 
		image : <Site24x7Icon width={24} height={24} /> ,
		is_active : true,
        displayed : true
	},
	{
		value : 'statuscake' , 
		label : 'StatusCake' , 
		description : 'Send webhooks to update your status page' , 
		image : <StatusCakeIcon width={24} height={24} /> ,
		is_active : true,
        displayed : true
	}, 

]
/**
 * 
 */
export const userPermisions = [
    {
        value : 'OWNER',
        label : 'Owner'
    },
    {
        value : 'READ_WRITE',
        label : 'Editor'
    },
    {
        value : 'READ_ONLY',
        label : 'Read Only'
    }

]

export const pricingPlans = [
    {
        value : 'free',
        label : 'Free',
        subtitle : 'Essential features and support for small projects and teams',
        price : 0,
        features : [
            'Unlimited team members',
            'Unlimited components',
            'Unlimited incidents',
            'Email notifications',
            'Basic customization',
            
        ]
    },
    {
        value : 'pro',
        label : 'Pro',
        subtitle : 'Powerful features and priority support for businesses and professionals',
        price : 9,
        features : [
            'Unlimited team members',
            'Unlimited components',
            'Unlimited incidents',
            'Email notifications',
            'Basic customization',
            'Custom domain',
        ]
    },
    /* {
        value : 'business',
        label : 'Business',
        subtitle : 'Basic communication for small projects and teams',
        price : 60,
        features : [
            'Unlimited team members',
            'Unlimited components',
            'Unlimited incidents',
            'Email notifications',
            'Basic customization',
            'Custom domain',
        ]
    } */
]